import React, { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./popupsright.css";
import light from "../images/light.png";

const BoltButtonWithDropdown = () => {
  const btnRef = useRef(null);
  const popupRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // detect mobile / desktop
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // inchide la click in afara
  useEffect(() => {
    const close = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("stats-popup-open");
    } else {
      document.body.classList.remove("stats-popup-open");
    }

    return () => {
      document.body.classList.remove("stats-popup-open");
    };
  }, [open]);

  return (
    <div className="first-main-pagi-bolt-wrapper">
      {/* BUTON */}
      <div
        ref={btnRef}
        className="first-main-pagi-stats-button"
        onClick={() => setOpen(!open)}
      >
        <span className="first-main-pagi-stats-icon">XP</span>
        <div className="first-main-pagi-stats-number">0</div>
      </div>

      {open && createPortal(
        <>
          <div
            className="first-main-pagi-overlay"
            onClick={() => setOpen(false)}
          />

          <div
            ref={popupRef}
            className={`first-main-pagi-popup first-main-pagi-bolt-popup ${
              isMobile ? "mobile" : "desktop"
            }`}
            style={{ minWidth: 220 }}
          >
            <div className="first-main-pagi-popup-header">
              <div className="orientation-title-popup-main">
                <span className="first-main-pagi-stats-icon" style={{fontSize: 22, marginRight: 8}}>XP</span>
                <p className="distance-coin">Sold XP</p>
              </div>
            </div>
            <div className="coin-balance-details">
              <div className="coin-row">
                <span>XP azi:</span>
                <span className="coin-amount">0</span>
              </div>
              <div className="coin-row">
                <span>XP saptamana aceasta:</span>
                <span className="coin-amount">0</span>
              </div>
              <div className="coin-row">
                <span>XP total:</span>
                <span className="coin-amount">0</span>
              </div>
            </div>
            <div className="first-main-pagi-popup-item-xp">
              <span className="color-button-streak">Castiga XP</span>
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};

export default BoltButtonWithDropdown;
